export const nombreDeAcciones = {

    // DATOS GENERALES DEL SISTEMA
    SETEAR_RANGO_DE_EDADES: "SETEAR_RANGO_DE_EDADES",
    // MENU SELECTED ITEMS
    SET_MENU_ITEM_GROUP:"SET_MENU_ITEM_GROUP",
    SET_MENU_ITEM:"SET_MENU_ITEM",

    FECHA_INICIAL: new Date(2022, 11, 1),
    FECHA_FINAL:new Date(2023, 1, 29),
    TOTAL_DIAS_CALENDARIO: (new Date(2023, 1, 29) - new Date(2022, 11, 1)) / (1000 * 60 * 60 * 24),

    SET_CURRENT_USER:"SET_CURRENT_USER",
    SET_MENU:"SET_MENU",
    LOGOUT:"LOGOUT",
    REGISTER:"REGISTER",

    SIGNUP_SET_DATA : "SIGNUP_SET_DATA",
    OBTENER_DEPARTAMENTOS: "OBTENER_DEPARTAMENTOS",
    OBTENER_MUNICIPIOS: "OBTENER_MUNICIPIOS",
    LIMPIAR_LOS_MUNICIPIOS: "LIMPIAR_LOS_MUNICIPIOS",
    GET_POLITICALSORGANIZATIONS: "GET_POLITICALSORGANIZATIONS",
    SET_DATA_IDOP: "SET_DATA_IDOP",

    // NUEVO CANAL
    LIMPIAR_TODO_EL_REDUCER: "LIMPIAR_TODO_EL_REDUCER",
    SETEAR_DATOS_DEL_CANAL: "SETEAR_DATOS_DEL_CANAL",
    SETEAR_TARIFARIO_Y_DISPONIBILIDAD: "SETEAR_TARIFARIO_Y_DISPONIBILIDAD",
    SETEAR_DATOS_COBERTURAS: "SETEAR_DATOS_COBERTURAS",
    SETEAR_DATOS_DEMOGRAFICOS: "SETEAR_DATOS_DEMOGRAFICOS",
    // NUEVA_RADIO
    SETEAR_DATOS_DE_LA_RADIO: "SETEAR_DATOS_DE_LA_RADIO",
    SETEAR_DATOS_DEL_MEDIO_ESCRITO: "SETEAR_DATOS_DEL_MEDIO_ESCRITO",
    SETEARINDICE: "SETEARINDICE",
    // CATALOGOS DE ESCRITOS
    SETEAR_TIPOS_DE_CIRCULACION_DEL_MEDIO: "SETEAR_TIPOS_DE_CIRCULACION_DEL_MEDIO",
    SETEAR_TIPO_DE_MEDIOS_ESCRITO: "SETEAR_TIPO_DE_MEDIOS_ESCRITO",
    SETEAR_TIPO_DE_DISTRIBUCION_DEL_MEDIO: "SETEAR_TIPO_DE_DISTRIBUCION_DEL_MEDIO",
    SETEAR_TIPO_DE_VALLAS_FIJAS: "SETEAR_TIPO_DE_VALLAS_FIJAS",
    SETEAR_TIPO_DE_VISUALIZACION: "SETEAR_TIPO_DE_VISUALIZACION",
    SETEAR_TIPO_DE_TRANSPORTE: "SETEAR_TIPO_DE_TRANSPORTE",
    SETEAR_TIPO_DE_MEDIO_DE_COMUNICACION: "SETEAR_TIPO_DE_MEDIO_DE_COMUNICACION",
    SETEAR_REGISTROS_PLAN_DE_MEDIOS_TELEVISION: "SETEAR_REGISTROS_PLAN_DE_MEDIOS_TELEVISION",
    SETEAR_REGISTROS_PLAN_DE_MEDIOS_RADIO: "SETEAR_REGISTROS_PLAN_DE_MEDIOS_RADIO",
    SETEAR_REGISTROS_PLAN_DE_MEDIOS_ESCRITOS: "SETEAR_REGISTROS_PLAN_DE_MEDIOS_ESCRITOS",
    SETEAR_PRESUPUESTO_PLAN_DE_MEDIOS: "SETEAR_PRESUPUESTO_PLAN_DE_MEDIOS",
    SETEAR_TARIFAS_PLAN_DE_MEDIOS: "SETEAR_TARIFAS_PLAN_DE_MEDIOS",
    SETEAR_PRESUPUESTO_GASTADO: "SETEAR_PRESUPUESTO_GASTADO",
    SETEAR_FECHAS_ORDENES: "SETEAR_FECHAS_ORDENES",
    SET_DATA_COMPANY: "SET_DATA_COMPANY",
    SET_DATA_INDIVIDUAL_PERSON_LIST: "SET_DATA_INDIVIDUAL_PERSON_LIST",
    SET_DATA_PERSON_ISSUING_THE_INVOICE: "SET_DATA_PERSON_ISSUING_THE_INVOICE",
    CLEAN_DATA_PERSON_ISSUING_THE_INVOICE: "CLEAN_DATA_PERSON_ISSUING_THE_INVOICE",
    SET_DATA_LEGAL_PERSON: "SET_DATA_LEGAL_PERSON",
    CLEAN_DATA_LEGAL_PERSON: "CLEAN_DATA_LEGAL_PERSON",
    SET_DATA_MEDIUM_CARACTERISTICS: "SET_DATA_MEDIUM_CARACTERISTICS",
    SET_DATA_COVERAGE: "SET_DATA_COVERAGE",
    SET_DATA_CARACTERISTICAS_MEDIOS: "SET_DATA_CARACTERISTICAS_MEDIOS",
    SET_DATA_ACTIVE_AND_NUMBER_STEP: "SET_DATA_ACTIVE_AND_NUMBER_STEP",
    CLEAN_ALL_REDUCER: "CLEAN_ALL_REDUCER",
    SETEAR_ALL_REDUCER: "SETEAR_ALL_REDUCER",
};